import React from "react";
import { Spinner } from "react-bootstrap";
import Animation from "../../../assets/images/loading5.gif";

const Loader = () => {
  return (
    <>
      <div className="loading m-auto d-flex  align-items-center justify-content-center">
        {/* <img src={Animation} alt="loading img" className="w-50 m-auto d-block" ></img> */}
        <Spinner className="" animation="border" variant="secondary" />
      </div>
    </>
  );
};

export default Loader;
